import axios from "axios";

export const COURSE_SUBJECT_URL = "/CourseSubject";

/** Belli Bir Ders Konusu Listesini Elde Eder */
export function getCourseSubjects(queryParams) {
  return axios.post(`${COURSE_SUBJECT_URL}/GetCourseSubjects`, queryParams);
}

/** Belli Bir Ders Konusu Listesini Sayfalama Olmadan Elde Eder */
export function getAllCourseSubjects(queryParams) {
  return axios.post(`${COURSE_SUBJECT_URL}/GetAllCourseSubjects`, queryParams);
}

/** Yeni Bir Ders Konusu Elde Eder */
export function getNewCourseSubject(courseId) {
  return axios.get(`${COURSE_SUBJECT_URL}/GetNewCourseSubject/${courseId}`);
}

/** Belli Bir Ders Konusunu Elde Eder */
export function getCourseSubject(id) {
  return axios.get(`${COURSE_SUBJECT_URL}/${id}`);
}

/** Belli Bir Ders Konusunu Kaydeder */
export function saveCourseSubject(subject) {
  return axios.post(COURSE_SUBJECT_URL, subject);
}

/** Belli Bir Ders Konusu ve Konulara Ait Kazanım Listesini Kaydeder */
export function saveCourseSubjectAndOutcomes(subjectAndOutcomes) {
  return axios.post(`${COURSE_SUBJECT_URL}/Save`, subjectAndOutcomes);
}

/** Belli Bir Ders Konusu Listesini Siler */
export function deleteCourseSubjects(ids) {
  return axios.post(`${COURSE_SUBJECT_URL}/Delete`, ids);
}